import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-liris-v2',
  templateUrl: './liris-v2.component.html',
  styleUrls: ['./liris-v2.component.css']
})
export class LirisV2Component implements OnInit {

    @Input('paramFormLirisV2') paramFormLirisV2: FormGroup;
    @Input('readOnly') readOnly: boolean;

  constructor() { }

  ngOnInit() {
  }

}
